export default __webpack_public_path__ + "static/media/bmw-m3.61ede4d5.jpg";